<template>
  <div class="background_enterprise">
    <div class="enterprise_index_text">
      <p style="font-size: 22px;margin-bottom: 1vh">我们投资的企业</p>
      <p style="font-size:28px; margin-bottom: 2vh;">有勇气试错 有勇气面对失败</p>
      <p>————</p>
      <p>十余年来，海纳亚洲已经凝聚了超过350+家被投企业，</p>
      <p>并且陪伴被投企业共同经历了完整的经济和投资周期，</p>
      <p>这使得我们在行业的广度、洞见的深度上积累了经验。</p>
      <p>创业，失败必然，成功偶然。因此，我们寻找的人，有勇气试错，</p>
      <p>有勇气面对失败。我们寻找的人，见解独立，与众不同。</p>
      <p>我们寻找的人，感念际遇，不生苦毒，尊重对手，战胜自己。</p>
      <p>我们首先成为这样的人，我们就将找到这样的人。</p>
      <p>我们尊重成功者，也尊重失败者；在我们的版图上，只有强者。</p>
      <p>无论是洼地的雏凤，还是登顶的雄鹰，</p>
      <p>我们相信，不忘初心，终得始终。</p>
      <p>一路之上，我们是同行者，分享暗淡与荣光; </p>
      <p>浮华之后，我们见证周期，更信仰人的可能性。</p>
      <div class="index_down">
        <a-button type="ghost" shape="circle-outline" size="large">
          <template v-slot:icon>
            <DownOutlined>
            </DownOutlined>
          </template>
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import {DownOutlined} from '@ant-design/icons-vue'

export default {
  name: "Enterprise_index_m",
  components: {
    DownOutlined,
  },
  setup() {
    const next_page = () => {
      document.documentElement.scrollBy({
        top: window.innerHeight * 92 / 100,
        behavior: "smooth",
      })
    }
    return {next_page}
  }
}
</script>

<style scoped>
.enterprise_index_text {
  padding-top: 26vh;
  text-align: center;
}

.enterprise_index_text p {
  font-size: 11px;
  margin-bottom: 5px;
}

.background_enterprise {
  background-image: url("../../../assets/background/enterprise_index.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  margin: 0;
}

</style>